import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Spinner, Badge } from "react-bootstrap";
import { fetchDashboardStats } from "../../service/apiService";
import "./DashboardHome.css";

const DashboardHome = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardStats()
      .then((res) => {
        if (res.status === "success") {
          setStats(res.data);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="dashboard-loader">
        <Spinner animation="border" />
      </div>
    );
  }

  const engagement = stats.messages_sent
    ? Math.round((stats.replies_received / stats.messages_sent) * 100)
    : 0;

  const openLog = (activity) => {
    const query = new URLSearchParams();
    if (activity?.action) {
      query.set("search", activity.action);
    } else if (activity?.description) {
      query.set("search", activity.description);
    }

    navigate(`/dashboard/super-admin/logs${query.toString() ? `?${query.toString()}` : ""}`);
  };

  const renderActivitySubtitle = (activity) => {
    const text = String(activity?.description || "");
    const [headline, ...rest] = text.split(" | ");
    const cleanHeadline = headline || text || "-";
    const tail = rest.join(" | ");

    return { cleanHeadline, tail };
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h2>Dashboard Overview</h2>
        <p>Here’s what’s happening with your account today.</p>
      </div>
<Row className="g-4 kpi-row">

  {/* Total Contacts */}
  <Col xs={12} sm={6} xl={3}>
    <Card className="kpi-card">
      <Card.Body>
        <div className="kpi-top">
          <div className="kpi-icon blue">
            <i className="bi bi-people-fill"></i>
          </div>
          <div className="kpi-trend up">↑ 8%</div>
        </div>

        <h2 className="kpi-value">{stats.total_contacts}</h2>
        <p className="kpi-label">Total Contacts</p>

        <div className="kpi-progress">
          <div style={{ width: "70%" }}></div>
        </div>
      </Card.Body>
    </Card>
  </Col>

  {/* Messages Sent */}
  <Col xs={12} sm={6} xl={3}>
    <Card className="kpi-card">
      <Card.Body>
        <div className="kpi-top">
          <div className="kpi-icon green">
            <i className="bi bi-send-fill"></i>
          </div>
          <div className="kpi-trend up">↑ 12%</div>
        </div>

        <h2 className="kpi-value">{stats.messages_sent}</h2>
        <p className="kpi-label">Messages Sent</p>

        <div className="kpi-progress">
          <div style={{ width: "60%" }}></div>
        </div>
      </Card.Body>
    </Card>
  </Col>

  {/* Replies */}
  <Col xs={12} sm={6} xl={3}>
    <Card className="kpi-card">
      <Card.Body>
        <div className="kpi-top">
          <div className="kpi-icon orange">
            <i className="bi bi-chat-left-text-fill"></i>
          </div>
          <div className="kpi-trend down">↓ 3%</div>
        </div>

        <h2 className="kpi-value">{stats.replies_received}</h2>
        <p className="kpi-label">Replies Received</p>

        <div className="kpi-progress">
          <div style={{ width: "40%" }}></div>
        </div>
      </Card.Body>
    </Card>
  </Col>

  {/* Engagement (Improved Special Card) */}
  <Col xs={12} sm={6} xl={3}>
    <Card className="kpi-card engagement-card">
      <Card.Body>
        <div className="engagement-icon">
          <i className="bi bi-graph-up-arrow"></i>
        </div>

        <div className="engagement-content">
          <h2 className="engagement-value">
            {engagement}
            %
          </h2>
          <p className="engagement-label">Engagement Rate</p>
        </div>

        <div className="engagement-ring">
            <div className="ring-inner">
            {engagement}
            %
          </div>
        </div>
      </Card.Body>
    </Card>
  </Col>

</Row>



      <Card className="activity-card glass mt-5">
        <Card.Body>
          <h5 className="section-title">Recent Activity</h5>

          <div className="activity-list">
            {stats.recent_activity.length === 0 ? (
              <div className="empty-state">No recent activity</div>
            ) : (
              stats.recent_activity.map((a, i) => (
                <button
                  key={i}
                  type="button"
                  className="activity-log-card text-start"
                  onClick={() => openLog(a)}
                >
                  <div className="activity-log-header">
                    <div className="activity-dot"></div>
                    <div className="activity-log-meta">
                      <div className="activity-title">{a.action}</div>
                      <div className="activity-time">{a.created_at}</div>
                    </div>
                    <Badge bg="light" text="dark" className="activity-chip">
                      View
                    </Badge>
                  </div>

                  <div className="activity-log-body">
                    {(() => {
                      const { cleanHeadline, tail } = renderActivitySubtitle(a);
                      return (
                        <>
                          <div className="activity-log-headline">{cleanHeadline}</div>
                          {tail ? <div className="activity-desc">{tail}</div> : null}
                        </>
                      );
                    })()}
                  </div>
                </button>
              ))
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default DashboardHome;
